module.exports = __webpack_public_path__ + "static/img/brand-value-2.29b6a23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand-culture/brand-value-2.png
// module id = 2Yqw
// module chunks = 1